<template>
  <v-content>
    <v-container fluid>
        <Header :title="'Tutor Product Coupons'" />
        <v-row>
            <v-col cols="12" sm="11" md="11">
            <v-card>
                <v-tabs
                v-model="tabs"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#viewcouponstab" @click="closeallpanels()"> {{ 'View Coupons' | translate}} </v-tab>
                    <v-tab href="#sendcouponstab" @click="closeallpanels()"> {{ 'Send Coupons' | translate }} </v-tab>
                </v-tabs>
            
            <v-tabs-items v-model="tabs">
                <v-tab-item value="viewcouponstab">
                    <v-card flat> 
                        <v-expansion-panels v-model="panelState" v-if="tutorvouchers.length>0">
                            <v-expansion-panel v-for="(voucherdata, index) in tutorvouchers" :key="index">
                                <v-expansion-panel-header @click="callcoupon(voucherdata.item_id)">
                                <h3>{{ voucherdata.item_name}} ({{voucherdata.tot_qty_left}}/{{voucherdata.tot_qty}} {{ 'Vouchers Available to Send' | translate}} )</h3>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                <v-row no-gutters>
                                    <v-col cols="12">
                                    <DataTable
                                        @revoking="revoking"
                                        :headers="headers"
                                        :items="tutorcoupons"
                                        :search="search"
                                        :itemkeyvalue="itemkeyvalue"
                                        :actiontitle="'Coupons'"
                                    />
                                    </v-col>
                                    <Dialogbox
                                        @closing="closing"
                                        @revokecoupon="revokecoupon()"
                                        :title="dialogboxtitle"
                                        :dialog="dialogstatus"
                                        :buttonTitle="dialogButtontitle"
                                        :revokecoupon="true"
                                        v-if="dialogstatus"
                                        />
                                </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>  
                        </v-expansion-panels>
                        <v-card-text v-else>
                          {{'No Tutor Products Available' | translate}}
                        </v-card-text>
                    </v-card>
                </v-tab-item>  
                <v-tab-item value="sendcouponstab">

                  

                     <v-card flat> 
                        <v-expansion-panels v-model="panelState" v-if="tutorvouchers.length>0">
                            <v-expansion-panel v-for="(voucherdata, index) in tutorvouchers" :key="index">
                                <v-expansion-panel-header @click="setcoupondata(voucherdata.item_id,voucherdata.tot_qty_left)">
                                <h3>{{ voucherdata.item_name}} ({{voucherdata.tot_qty_left}} {{ 'Vouchers Available to Send' | translate}} )</h3>
                                </v-expansion-panel-header>
                                <v-form id="form" ref="form">
                                <v-expansion-panel-content>
                                <v-row no-gutters>
                                    <v-col cols="10">
                                                    <v-row>
                                                        <v-col cols="12" sm="12" md="12">
                                                                <v-autocomplete
                                                                    v-model="coupontype"
                                                                    :items="coupongroupstype"
                                                                    :label="'Send To' | translate"
                                                                    item-value="value"
                                                                    item-text="name"
                                                                    outlined
                                                                    required
                                                                    @change="changeCouponType(voucherdata.item_id)"
                                                                >
                                                                </v-autocomplete>

                                                                  <v-autocomplete
                                                                    v-model="group_array"
                                                                    name="groups"
                                                                    :items="groups"
                                                                    item-value="group_id"
                                                                    :item-text="item =>`${item.group_name} (${item.total_users} Users)`"
                                                                    :label="'GroupsAdd' | translate"
                                                                    outlined
                                                                    chips
                                                                    small-chips
                                                                    multiple
                                                                    required
                                                                    v-if="coupontype=='groups'"
                                                                    :rules="groupRules"
                                                                    :no-data-text="$t('No data available')"
                                                                    >
                                                                    <template #message="{ message }">
                                                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                                    </template>  
                                                                    </v-autocomplete>

                                                                <v-autocomplete
                                                                    v-model="user_array"
                                                                    name="users"
                                                                    :items="users"
                                                                    item-value="user_id"
                                                                    :item-text="item =>`${item.email}`"
                                                                    :label="'UsersAdd' | translate"
                                                                    outlined
                                                                    chips
                                                                    small-chips
                                                                    multiple
                                                                    required
                                                                    v-if="coupontype=='users'"
                                                                    :rules="userRules"
                                                                    :no-data-text="$t('No data available')"
                                                                >
                                                                  <template #message="{ message }">
                                                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                                    </template>  
                                                                </v-autocomplete>

                                                                <v-combobox
                                                                    v-model="email_string"
                                                                    name="emails"
                                                                    :label="'Emails' | translate"
                                                                    outlined
                                                                    chips
                                                                    small-chips
                                                                    multiple
                                                                    required
                                                                    v-if="coupontype=='emails'"
                                                                    :rules="emailRules"
                                                                    append-icon="" 
                                                                >
                                                                <template #message="{ message }">
                                                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                                                </template> 
                                                                </v-combobox>
                                                                
                                                               
                                                        </v-col>
                                                
                                                    </v-row>
                                    </v-col>
                                </v-row>
                                <div v-if="limitReached()" class="v-messages theme--light error--text" role='alert'>{{'Limit Reached'|translate}}</div>
                                <v-btn
                                  @click="submit(index)"
                                  :disabled="(limitReached() ? true : false)"
                                >
                                  {{'Submit'|translate}}
                                </v-btn>
                                </v-expansion-panel-content>
                                </v-form>
                            </v-expansion-panel>  
                        </v-expansion-panels>
                        <v-card-text v-else>
                          {{'No Tutor Products Available' | translate}}
                        </v-card-text>
                    </v-card>
                </v-tab-item>    
            </v-tabs-items>   
            </v-card>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="messagedialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ message | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="messagedialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>

    </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex"
import store from "@/store";
import {
  FETCH_TUTOR_VOUCHERS,
  REVOKE_TUTOR_COUPON,
  LIST_TUTOR_COUPONS,
  FETCH_GROUPS,
  FETCH_USERS,
  SEND_TUTOR_COUPONS,
  RESET_STATE,
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "tutorProductCoupons",
   async mounted() {
    store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_TUTOR_VOUCHERS, '').then(resp => {
      if (resp.success) {
        this.tutorvouchers = resp.data
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
  },
  data: function() {
    return {
      tabs:null,
      tutor_product_id: null,
      tot_quantity_left: null,
      search: "",
      itemkeyvalue: 'coupon_id',
      dialogstatus: false,
      dialog: false,
      group_array: [],
      user_array: [],
      email_string: null,
      email_array: [],
      tutorcoupons:[],
      tutorvouchers:[],
      coupontype:null,  
      message: null,
      messagedialog: false,
      isLoading: false,
      panelState: null,
    }
  },
  computed: {
    ...mapGetters([
      "groups",
      "users",
      "loadingdata",
      "curLanguage",
    ]),
    ...mapState({
      curLanguage: state => state.translations.curLanguage,
    }),
    headers(){ return [
        { text: this.$t("Coupon"), value: "coupon_code" },
        { text: this.$t("Sent To"), value: "user.email" },
        { text: this.$t("Redeemed"), value: "status" },
        { text: this.$t("Revoke"), value: "revokeaction" }
        ]
    },
    coupongroupstype(){
        return [
        { value: "groups", name: this.$t('User Groups') },
        { value: "users", name: this.$t('Users') },
        { value: "emails", name: this.$t('Email Ids') }
        ]
    },
    groupRules(){ 
      return [v => v.length !==0 || "Groups are required"]
    },
    userRules(){ 
      return [v => v.length !==0 || "Users are required"]
    },
    emailRules(){ 
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
  },
  components: {
    Header: () => import("@/components/header/Header"),
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
  },  
  methods: {
    closing() {
      this.dialogstatus = false
    },
    setcoupondata(tutor_product_id,tot_quantity_left){
        this.tutor_product_id = tutor_product_id
        this.tot_quantity_left = tot_quantity_left
        this.tot_quantity_left = 2
        //On load of a new course, clear previous values
        this.coupontype = null
        this.group_array = []
        this.user_array = []
        this.email_array = []
        this.email_string = null

    },
    limitReached (){
        if(this.coupontype=='groups'){
            var total_user_count = 0

            this.group_array.forEach(element => {
                let obj = this.groups.find(x => x.group_id === element)
                let total_users = 0
                total_users = obj.total_users;
                total_user_count = total_user_count + total_users
            })
            
            return ((this.tot_quantity_left < total_user_count) ? true : false);
        }
        if(this.coupontype=='users'){
            return ((this.tot_quantity_left < (Object.keys(this.user_array).length)) ? true : false);
        }
        if(this.coupontype=='emails'){
            let emails = this.email_string;
            var email_array = [];
            if(emails!==null){
              email_array = emails.toString().split(/[ ,]+/);
            }
            return ((this.tot_quantity_left < (Object.keys(email_array).length)) ? true : false);
        }
    },
    async changeCouponType(tutor_product_id){
        if(this.coupontype=='groups'){
            Promise.all([
            await this.$store.dispatch(FETCH_GROUPS, '?tutor_product_id='+tutor_product_id),
            ]).then(() => {
            store.commit(SET_LOADING, false)
            })
        }
        if(this.coupontype=='users'){
            Promise.all([
            await this.$store.dispatch(FETCH_USERS, '?tutor_product_id='+tutor_product_id),
            ]).then(() => {
            store.commit(SET_LOADING, false)
            })
        }

    },
    async loadvouchers(){
      await store.dispatch(FETCH_TUTOR_VOUCHERS, '').then(resp => {
        if (resp.success) {
          this.tutorvouchers = resp.data
          store.commit(SET_LOADING, false);
          store.commit(SET_ROUTER_ENTER, false)
        }
      });
    },
    closeallpanels(){
      this.panelState = null
    },
    callcoupon(tutor_product_id){
      this.isLoading = true;
      this.tutor_product_id = tutor_product_id
        this.$store.dispatch(LIST_TUTOR_COUPONS, 'item_id='+tutor_product_id )
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.tutorcoupons = resp.data;
              store.commit(SET_LOADING, false);
              this.isLoading = false;
            }
            else{
              store.commit(SET_LOADING, false);
              this.isLoading = false;
            }
          });
    },
     submit(index) {
      if (this.$refs.form[index].validate()) {
        if(this.coupontype=='groups'){
            let senddata = {
                coupontype: this.coupontype,
                item_id: this.tutor_product_id,
                groups: this.group_array,
            }
            this.isLoading = true;
            this.$store
            .dispatch(SEND_TUTOR_COUPONS, senddata )
            .then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.messagedialog = true;
                  this.message = "Coupon Code Sent Successfully!";
                  this.loadvouchers();
                }
                else{
                  this.isLoading = false;
                  store.commit(SET_LOADING, false)
                  this.messagedialog = true;
                  this.message = "Some Problem occurred!";
                }
            });
        }
        if(this.coupontype=='users'){
            let senddata = {
                coupontype: this.coupontype,
                item_id: this.tutor_product_id,
                users: this.user_array,
            }
            this.isLoading = true;
            this.$store
            .dispatch(SEND_TUTOR_COUPONS, senddata )
            .then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.messagedialog = true;
                  this.message = "Coupon Code Sent Successfully!";
                  this.loadvouchers();
                }
                else{
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.messagedialog = true;
                  this.message = "Some Problem occurred!";
                }
            });
        }
        if(this.coupontype=='emails'){
          //Santitize the emails and pack into an array
          let emails = this.email_string;
          this.email_array = emails.toString().split(/[ ,]+/);
            let senddata = {
                coupontype: this.coupontype,
                item_id: this.tutor_product_id,
                emails: this.email_array,
            }
            this.isLoading = true;
            this.$store
            .dispatch(SEND_TUTOR_COUPONS, senddata )
            .then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.messagedialog = true;
                  this.message = "Coupon Code Sent Successfully!";
                  this.loadvouchers();
                }
                else{
                  this.isLoading = false;
                  store.commit(SET_LOADING, false);
                  this.messagedialog = true;
                  this.message = "Some Problem occurred!";
                }
            });
        }
      }
    },
    revoking(coupon_id) {
        this.dialogstatus = true
        this.dialogboxtitle = "Are you sure want to Revoke the Coupon?"
        this.dialogButtontitle = "Remove"
        this.coupon_id = coupon_id
    },
    async revokecoupon() {
      await this.$store
        .dispatch(REVOKE_TUTOR_COUPON, this.coupon_id)
        .then(async resp => {
          if (resp !=undefined && resp.success) {
                this.coupon_id = null;
                this.$store.dispatch(LIST_TUTOR_COUPONS, 'item_id='+this.tutor_product_id).then(resp => {
                if (resp.success) {
                    this.tutorcoupons = resp.data
                    store.commit(SET_LOADING, false);
                    this.isLoading = false
                    }
                }); 
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
          }
          else{
            store.commit(SET_LOADING, false);
            this.isLoading = false
          }
        });
    },
  }
};
</script>